const rZasielkovna = {
    apiKey: null,
    openModal() {
        Packeta.Widget.pick(
            this.apiKey,
            (data) => {
                this.processSelectedBranch(data)
            },
            {
                // ISO 639-1 code
                'language': Eshop.options.locale ? Eshop.options.locale.split('_')[0] : 'sk',
                'country': Eshop.options.locale ? Eshop.options.locale.split('_')[1].toLowerCase() : 'sk',
            }
        )
    },
    processSelectedBranch(data) {
        if (!data) {
            return
        }

        document.querySelector('[r-zasielkovna-holder]').classList.add('is-loading')
        document.querySelector('[r-zasielkovna-empty]').classList.remove('hidden')
        document.querySelector('[r-zasielkovna-selected]').classList.add('hidden')
        document.querySelector('input[name="shipping_module_id"][r-zasielkovna-input]').value = null

        $.post('/create-zasielkovna-branch', data, (response) => {
            if (!response.status) {
                this.failedCallback();

                return false;
            }

            data.id = response.data.id;

            this.successCallback(data);
        }, 'json')
            .fail(() => {
                console.error(error)
                this.failedCallback();
            });
    },
    failedCallback() {
        document.querySelector('input[name="shipping_module_id"][r-zasielkovna-input]').value = null
        document.querySelector('[r-zasielkovna-holder]').classList.remove('is-loading')
    },
    successCallback(data) {
        document.querySelector('input[name="shipping_module_id"][r-zasielkovna-input]').value = data.id
        document.querySelector('input[name="shipping_name"]').value = data.name
        document.querySelector('input[name="shipping_address"]').value = data.street
        document.querySelector('input[name="shipping_post_code"]').value = data.zip
        document.querySelector('input[name="shipping_city"]').value = data.city

        document.querySelector('[r-zasielkovna-selected]').classList.remove('hidden')
        document.querySelector('[r-zasielkovna-selected-branch]').innerText = data.place
        document.querySelector('[r-zasielkovna-selected-address]').innerText = data.name
        document.querySelector('[r-zasielkovna-empty]').classList.add('hidden')
        document.querySelector('[r-zasielkovna-holder]').classList.remove('is-loading')

        document.getElementById('error-branch').style.display = 'none'
    },
    init(apiKey) {
        if (!apiKey) {
            console.error('apiKey is not defined')

            return
        }

        if (!document.querySelector('[r-zasielkovna-input]')) {
            return;
        }

        this.apiKey = apiKey

        setTimeout(() => {
            document
                .querySelector('[r-zasielkovna-empty]')
                .closest('.js-shopping-modules-item')
                .querySelector('.js-accordion-header')
                .addEventListener('click', () => {
                    if (!document.querySelector('[r-zasielkovna-empty]').classList.contains('hidden')) {
                        this.openModal()
                    }
                })
        }, 100)

        for (const trigger of document.querySelectorAll('[r-zasielkovna-trigger]')) {
            trigger.addEventListener('click', (event) => {
                this.openModal()
            })
        }
    }
}

$(function() {
    rZasielkovna.init('079cc71f6bb7cc1e');
});
